var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.714286,
    y: 0.714286,
    width: 38.5714,
    height: 38.5714,
    rx: 19.2857,
    stroke: "#82B5D1",
    strokeWidth: 1.42857
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2386 17.6812V18.3955H21.9529H24.6281L24.2831 20.588H21.9529H21.2386V21.3023V29.3465H18.7177V21.3023V20.588H18.0034H15.5147V18.3955H18.0034H18.7177V17.6812V14.9201C18.7177 13.4943 19.1428 12.4742 19.811 11.8109C20.4799 11.1468 21.475 10.7581 22.775 10.7573C23.4907 10.7662 24.205 10.8157 24.9146 10.9056V12.6555H24.0103C23.0728 12.6555 22.3405 12.9511 21.8553 13.5082C21.3862 14.0469 21.2386 14.727 21.2386 15.3275V17.6812Z",
    stroke: "#82B5D1",
    strokeWidth: 1.42857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fcdedb4fe7fbba4b3d47027486c31844.svg";
export { ForwardRef as ReactComponent };